
import {observer} from 'mobx-react';
import {Spin} from 'antd';
import {useStore} from '@/store/root-store';
import styled from 'styled-components';
import {LoadingOutlined} from '@ant-design/icons';
import {isNil} from 'lodash';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faRotateRight} from '@fortawesome/pro-regular-svg-icons';

export const PageSpeedIndex = observer(() => {
  const secondAntIcon = <LoadingOutlined style={{marginTop: '-3px', color: '#7f4ead', marginLeft: '5px'}} spin />;

  const {
    contentOptimizer: {
      currentPage,
    }} = useStore('');

  const generateDotWithColor = (status?: string) => {
    if (status) {
      if (status === 'Fast' || status === 'Good') return <SpeedIndexDot style={{backgroundColor: '#2AC155'}}></SpeedIndexDot>;
      if (status === 'Moderate' || status === 'Average' || status === 'Ok') return <SpeedIndexDot style={{backgroundColor: '#FF8536'}}></SpeedIndexDot>;
      if (status === 'Slow' || status === 'Bad') return <SpeedIndexDot style={{backgroundColor: '#F44343'}}></SpeedIndexDot>;
    } else {
      return <div style={{marginLeft: '8px'}}></div>;
    }
  };

  const refetchArticle = uuid => {
    currentPage?.refetchPage(uuid);
  };
  // currentPage.isInitialPageLoad
  return <Container>
    <SpeedIndexContainer>
      Page Speed Index:
      {!currentPage?.isWordCountLoading ? <>
        {generateDotWithColor(currentPage?.analysis?.psiMetrics?.avgSpeedIndex?.status) }
        {!isNil(currentPage?.analysis?.psiMetrics?.avgSpeedIndex?.score) ? <><span>{Math.round(currentPage?.analysis?.psiMetrics?.avgSpeedIndex?.score * 100)}</span><span style={{fontSize: 10, color: '#A3A4A4'}}>/100</span></> : null}
      </>:
        <Spin indicator={secondAntIcon}/> }
    </SpeedIndexContainer>


    <LastFetchContainer>
      <span >Last Fetch: </span>
      <span style={{marginLeft: '5px'}}>{!currentPage?.content?.updatedAt ? <Spin indicator={secondAntIcon}/>: moment(currentPage?.content?.updatedAt).format('DD MMM YYYY')}</span>
      <FontAwesomeIcon icon={faRotateRight} style={{marginLeft: '5px', color: '#A3A4A4', cursor: 'pointer'}} spin={currentPage?.isInitialPageLoad || currentPage?.isTechnicalsDataLoading} onClick={() => refetchArticle(currentPage?.content?.uuid) }/>

    </LastFetchContainer>
  </Container>;
});


const Container = styled.div`
  cursor: default;
`;
const SpeedIndexContainer = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #e8e8e8 !important;
  cursor: default;
  margin-top: 5px;
`;
const LastFetchContainer = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #e8e8e8 !important;
  cursor: default;
`;
const SpeedIndexDot = styled.div`
  border-radius: 2px;
  height: 4px;
  margin-left: 8px;
  margin-right: 3px;
  width: 4px;
`;
